module.exports = __webpack_public_path__ + "media/a3.00a9008b.mp3";